<template>
  <div class="collection">
    <div class="container">
      <div class="row center-xs">
        <header class="col-md-12">
          <h3 class="align-left cl-accent h3 m0">
            {{ title }}
          </h3>
        </header>
      </div>
    </div>
    <div class="collection-slider">
      <div class="container px15">
        <div class="row">
          <div class="col-md-12">
            <div class="center-xs cool-stuff-collection">
              <no-ssr>
                <carousel v-bind="config" @pageChange="setMuted">
                  <slide
                    v-for="product in products"
                    :key="product.id"
                    :categoryProps="product.catalog"
                  >
                    <product-tile
                      class="collection-product"
                      :product="product"
                      :categoryProps="product.catalog"
                      :labels-active="false"
                      :only-image="false"
                      :showStatus="showStatus"
                      :isBadge="isBadge"
                      :isH4="isH4"
                    />
                  </slide>
                </carousel>
              </no-ssr>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoSSR from 'vue-no-ssr'
import ProductTile from 'theme/components/core/ProductTile'
import config from 'config'

export default {
  name: 'ProductsSlider',
  props: {
    title: {
      type: String,
      default: ''
    },
    products: {
      type: Array,
      required: true
    },
    categoryProps: {
      type: String,
      default: config.rootcategories.drukowanie
    },
    config: {
      type: Object,
      required: true
    },
    showStatus: {
      type: Boolean,
      default: true,
      required: false
    },
    isBadge: {
      type: Boolean,
      default: false,
      required: false
    },
    isH4: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  components: {
    'Carousel': () => import(/* webpackChunkName: "vue-carousel" */ 'vue-carousel').then(Slider => Slider.Carousel),
    'Slide': () => import(/* webpackChunkName: "vue-carousel" */ 'vue-carousel').then(Slider => Slider.Slide),
    ProductTile,
    'no-ssr': NoSSR
  },
  data () {
    return {
      currentPage: 0,
    }
  },
  methods: {
    setMuted (currentPage) {
      this.currentPage = currentPage
    }
  }
}
</script>

<style lang="scss">
@import '~theme/css/variables/colors';
@import '~theme/css/variables/grid';
@import '~theme/css/helpers/functions/color';
$color-product-bg: color(secondary, $colors-background);

.collection {
  margin-bottom: 30px;
  border: solid 1px #cbd3dd;
  border-radius: $gutter-size;
  overflow: hidden;
  width: 100%;
  padding-bottom: $gutter-size;
  background: #fff;

  @include sm-up {
    border-radius: 36px;
  }

  @include lg-up {
    border-radius: 36px;
  }

  header {
    background: #fff;
    border-bottom: solid 1px #cbd3dd;
    display: block;
    padding: 0px 25px;
    border-top-left-radius: $gutter-size;
    border-top-right-radius: $gutter-size;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 60px;

    h2 {
      margin: 0px;
      padding: 0px;
      font-size: 22px;
      font-weight: 400;
      color: #000000;
      font-family: "Roboto", sans-serif;
    }

    @include sm-up {
      border-top-left-radius: 36px;
      border-top-right-radius: 36px;
    }

    @include lg-up {
      border-top-left-radius: 36px;
      border-top-right-radius: 36px;
    }

    @media (max-width: 375px) {
      min-height: 40px;
      padding-left: 15px;

      h3.h3 {
        font-size: 18px;
      }
    }
  }
}
.collection-slider {
  .VueCarousel-wrapper {
    overflow: hidden !important;
    &:before,
    &:after {
      content: "";
      height: 100%;
      position: absolute;
      top: 0;
      z-index: 1;
      display: none;
      @media only screen and (min-width: 576px) {
        display: block;
        width: calc((100vw - (560px - 30px)) / 2);
      }

      @media only screen and (min-width: 768px) {
        width: calc((100vw - (752px - 30px)) / 2);
      }

      @media only screen and (min-width: 992px) {
        width: calc((100vw - (976px - 30px)) / 2);
      }

      @media only screen and (min-width: 1200px) {
        width: calc((100vw - (1184px - 30px)) / 2);
      }
    }
    &:before {
      right: 100%;
      background: linear-gradient(to right, $color-product-bg 0%,$color-product-bg 40%,rgba($color-product-bg,0.2) 100%);
    }
    &:after {
      left: 100%;
      background: linear-gradient(to left, $color-product-bg 0%,$color-product-bg 40%,rgba($color-product-bg,0.2) 100%);
    }
  }

  .VueCarousel-navigation {
    position: absolute;
    top: -42px;
    right: 15px;
    @media (max-width: 768px) {
      right: 10px;
    }
    @media (max-width: 375px) {
      top: -30px;
      right: 0px;
    }
    .VueCarousel-navigation-button {
      width: 21px;
      height: 21px;
      text-indent: -9999px;
      transform: none !important;
      top: 0px !important;
      margin: 0px !important;
      &.VueCarousel-navigation-prev {
        right: 28px;
        left: auto;
        background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMSAyMSI+CiAgPHBhdGggaWQ9Ik9wX2NvbXBvbmVudF8xIiBkYXRhLW5hbWU9Ik9wIGNvbXBvbmVudCAxIiBkPSJNMTM5MC45LDYxNy42MzlhMS4wMTQsMS4wMTQsMCwwLDEsLjMzNC43NDMuOTc2Ljk3NiwwLDAsMS0uMjM4LjYzN2wtMS4yNzYsMS40OTFoNS43NjJhLjk4OC45ODgsMCwwLDEsMCwxLjk3N2gtNS43NjJsMS4yNzMsMS40ODlhLjk1My45NTMsMCwwLDEsLjI0OS42NDQuOTc2Ljk3NiwwLDAsMS0uMzQ5Ljc0NiwxLjAwNiwxLjAwNiwwLDAsMS0uNjU0LjIzLjk2Mi45NjIsMCwwLDEtLjc1Ni0uMzMybC0zLjI0Ny0zLjc2NSwzLjI0NS0zLjc2NGEuOTkxLjk5MSwwLDAsMSwxLjQxMi0uMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzgxIC02MTEpIiBmaWxsPSIjYTRiMWMyIi8+CiAgPHBhdGggaWQ9Ik9wX2NvbXBvbmVudF8yIiBkYXRhLW5hbWU9Ik9wIGNvbXBvbmVudCAyIiBkPSJNMTM5OC45MjUsNjE0LjA3NUExMC41LDEwLjUsMCwxLDEsMTM5MS41LDYxMSwxMC40MzEsMTAuNDMxLDAsMCwxLDEzOTguOTI1LDYxNC4wNzVabS0xNS45NDgsNy40MjVhOC41MjMsOC41MjMsMCwxLDAsOC41MjMtOC41MjNBOC41MzMsOC41MzMsMCwwLDAsMTM4Mi45NzcsNjIxLjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTM4MSAtNjExKSIgZmlsbD0iI2E0YjFjMiIvPgo8L3N2Zz4K")
          no-repeat;
      }
      &.VueCarousel-navigation-next {
        right: 0px;
        left: auto;
        background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMSAyMSI+CiAgPHBhdGggaWQ9Ik9wX2NvbXBvbmVudF8xIiBkYXRhLW5hbWU9Ik9wIGNvbXBvbmVudCAxIiBkPSJNMTQyMC4xLDYxNy42MzlhMS4wMTQsMS4wMTQsMCwwLDAtLjMzNC43NDMuOTc2Ljk3NiwwLDAsMCwuMjM4LjYzN2wxLjI3NSwxLjQ5MWgtNS43NjJhLjk4OC45ODgsMCwwLDAsMCwxLjk3N2g1Ljc2MmwtMS4yNzMsMS40ODlhLjk1NC45NTQsMCwwLDAtLjI0OS42NDQuOTc2Ljk3NiwwLDAsMCwuMzQ5Ljc0NiwxLjAwNywxLjAwNywwLDAsMCwuNjU0LjIzLjk2Mi45NjIsMCwwLDAsLjc1Ni0uMzMybDMuMjQ3LTMuNzY1LTMuMjQ1LTMuNzY0YS45OS45OSwwLDAsMC0xLjQxMi0uMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNDA5IC02MTEpIiBmaWxsPSIjYTRiMWMyIi8+CiAgPHBhdGggaWQ9Ik9wX2NvbXBvbmVudF8yIiBkYXRhLW5hbWU9Ik9wIGNvbXBvbmVudCAyIiBkPSJNMTQxMi4wNzUsNjE0LjA3NUExMC41LDEwLjUsMCwxLDAsMTQxOS41LDYxMSwxMC40MzIsMTAuNDMyLDAsMCwwLDE0MTIuMDc1LDYxNC4wNzVabTE1Ljk0OCw3LjQyNWE4LjUyMyw4LjUyMywwLDEsMS04LjUyMy04LjUyM0E4LjUzMyw4LjUzMywwLDAsMSwxNDI4LjAyMyw2MjEuNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNDA5IC02MTEpIiBmaWxsPSIjYTRiMWMyIi8+Cjwvc3ZnPgo=")
          no-repeat;
      }
    }
  }
}

.product {
  &.collection-product {
    padding: 0;
  }
}

.collection-product {
  .product-link {
    display: block;
    padding: 0 15px;
  }

  .product-image {
    height: auto;
    will-change: opacity;

    img {
      max-width: 100%;
      max-height: 100%;
      height: auto;
      vertical-align: bottom;
    }
  }
}
</style>
